import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from "antd";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { actions } from "store";
import { ordering } from "utils";
import { TableList, ActionButton } from "components/common";


class CountryList extends Component {
    load = (filter) => {
        const { actions, geo_country } = this.props;
        let newFilter = Object.assign({}, filter);
        if (newFilter.activeFilter === undefined) {
            newFilter.activeFilter =  geo_country.filter.activeFilter
        }
        actions.geoCountryLoad(newFilter);
    };

    render() {
        const { history, actions, defaultFilter, activeFilter, geo_country } = this.props;
        const params = geo_country.filter.params;

        const columns = [
            {
                title: 'Название',
                dataIndex: 'name_en',
                key: 'name_en',
                render: (text, item) => <Link to={`/country/${item.id}`}>{text}</Link>,

                sorter: true,
                sortOrder: ordering('name_en', params.ordering),
            },
            {
                title: 'Путь',
                dataIndex: 'slug',
                key: 'slug',
            },
            {
                title: 'Кол-во городов',
                dataIndex: 'city_count',
                key: 'city_count',
                width: 150,
            },
            {
                title: 'Кол-во анкет',
                dataIndex: 'profile_count',
                key: 'profile_count',
                width: 150,
            },
            {
                title: 'Действия',
                dataIndex: 'actions',
                key: 'actions',
                width: 130,
                align: 'right',
                render: (val, item) => {
                    return (
                        <ActionButton
                            actions={[
                                {
                                    key: 'edit',
                                    icon: <Icon type="edit"/>,
                                    title: 'Редактировать',
                                    action: () => actions.geoCountryShowEditForm({ show: true, object: item }),
                                },
                                {
                                    key: 'delete',
                                    icon: <Icon type="delete"/>,
                                    title: 'Удалить',
                                    action: () => actions.geoCountryDelete({ id: item.id }),
                                    confirm: {
                                        title: 'Уверены, что хотите удалить?',
                                        okText: 'Удалить',
                                        cancelText: 'Отмена'
                                    }
                                },
                            ]}

                        />
                    )
                }
            }
        ];

        return (
            <TableList
                history={history}
                defaultFilter={defaultFilter}
                activeFilter={activeFilter}
                data={geo_country}
                columns={columns}
                onLoadData={this.load}
                plural={['страна', 'страны', 'стран']}
                onRow={(item, rowIndex) => {
                    return {
                        onDoubleClick: event => {
                            this.props.history.push(`/country/${item.id}`);
                        },
                    };
                }}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        geo_country: state.geo_country,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, actions.geo_country), dispatch),
        dispatch: dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CountryList);
